var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangecredit01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4e211;}.cls-2{fill:#8dd463;}.cls-3{fill:#be5521;}.cls-4{fill:#2ca0ff;}.cls-5{clip-path:url(#clip-path);}.cls-6{clip-path:url(#clip-path-2);}.cls-15,.cls-7{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}.cls-7{stroke-width:3px;}.cls-8{clip-path:url(#clip-path-3);}.cls-9{clip-path:url(#clip-path-4);}.cls-10{clip-path:url(#clip-path-5);}.cls-11{fill:#f5f1e5;}.cls-12{clip-path:url(#clip-path-6);}.cls-13{clip-path:url(#clip-path-7);}.cls-14{clip-path:url(#clip-path-8);}.cls-15{stroke-width:2px;}.cls-16{clip-path:url(#clip-path-9);}.cls-17{fill:#ebc2fd;}.cls-18{clip-path:url(#clip-path-10);}.cls-19{clip-path:url(#clip-path-11);}.cls-20{clip-path:url(#clip-path-12);}.cls-21{fill:#fd725d;}.cls-22{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M901.92,57.42l142.84-12.17a6.47,6.47,0,0,1,7,6l6.58,98a6.46,6.46,0,0,1-6,6.89L910.25,166.82a6.47,6.47,0,0,1-7-6L896,64.36A6.48,6.48,0,0,1,901.92,57.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M594.12,288.48c13.42-19.86,36-10,89.85-26.1,23.17-6.92,71.94-23.23,109.55-64.21,11.68-12.73,22.13-27.23,28.84-43.1a15.67,15.67,0,0,1,21.88-7.78,128.66,128.66,0,0,1,49.55,48.11,15.81,15.81,0,0,1,1.05,13.77C848.84,325.3,774,404.58,698.2,405.4c-12.07.13-59.92.64-88.91-33.95C590.4,348.93,579,310.88,594.12,288.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M821.82,151.26c-1.94-19.84,1.3-47.42,22.92-76.89,0,0,5.51-17.1,9.47-28.59a20.3,20.3,0,0,1,23.63-13.25c7.64,1.73,16.25,6.88,23.68,19.27C905,32,923.23,19.23,940.3,22.05c13.73,2.26,25.13,14.3,27.37,29.75l-20,3.25s-2.23,38.41-46.31,47.71l1.78,28.83a34.29,34.29,0,0,0,37.19,32.07l52.7-4.55s13.48,41.78-34.38,31.13c0,0-17.32-2.24-26.83,6.5a47.44,47.44,0,0,1-8.84,6.6c-12.08,6.74-38.86,17.62-66.81,1.88C836.52,194.14,824,173.73,821.82,151.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.82,650.46a202.53,202.53,0,0,1,1.63,21.72s10,11.83,14.24,25.74A24,24,0,0,1,400,728.72c-10.82-.74-25.11-4.54-40.47-16.23a125.1,125.1,0,0,0,12.6,27.6,24,24,0,0,1,1.49,23.47c-5.24,10.37-19.2,18.1-55.8-2.37,0,0-23.43,19.18-54-20.36,0,0-26.25,13-38-26.89a94.15,94.15,0,0,1-2.6-40.24c4.73-32.3,21.91-100.52,82.88-109.16,0,0,1.4-.11,4-.13A98.91,98.91,0,0,1,408.82,650.46Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M499.46,300.76c-41.93,14.57-68.07,54.16-64.28,93.84,4.51,47.34,49.25,70,51.78,71.24a170.17,170.17,0,0,1,15.57,32,175.38,175.38,0,0,1,9.25,81.61s-14.54,24.93,24.94,37l203.9-112.56c1.45-2.58,8.38-15.5,2.47-34.43C737,450,720.59,442.07,718,440.85L710,398.08c1.64-9.78,5-37.69-10.95-65-18.57-31.89-55.92-50.3-96.35-48.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M822.25,680.54s78.79,56.22,77,161.1A55.49,55.49,0,0,0,929,891.84a106.5,106.5,0,0,0,43.37,11.62,55.54,55.54,0,0,0,55.31-36c15.23-41,29.07-116.17-24.27-200-3.83-4.31-40.51-44.17-97.88-39-54.36,4.88-83,46.19-86.67,51.61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.08,505.86C543.81,531.05,516.41,580,521,631.58a125.23,125.23,0,0,0,13.17,46.14c27.92,54.56,94.76,83.64,160.05,66.31,16.59-4.88,33.45-10.19,50.64-15.74,28.46-9.19,63.19-21,88.29-31.51,0,0,129.82-51.61,306.75,12.18,25.67,9.25,54.71-.64,68.59-24.12.35-.6.7-1.21,1-1.82a57.84,57.84,0,0,0,6.34-18.33c3.27-19.83-4.36-39.86-19.38-53.2a503.54,503.54,0,0,0-91.11-63.85C1040.75,512,950,480,845.23,494.27c0,0-91.43,11-128.16,29.11h0a40.62,40.62,0,0,0-41.21-40.77,184.22,184.22,0,0,0-86.78,23.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.91,861.34c20.65,1.56,39.28,18,43.38,38.32,2.13,10.53.67,21.48,2.1,32.12,2.37,17.73,12.48,33.34,18.87,50.05,4.46,11.67,7.14,24.27,5.71,36.68s-7.34,24.63-17.47,32-23.79,9.13-36.27,7.08S991.11,1050,980,1044c-26.63-14.28-51.48-31.68-75.27-50.32-17.31-13.57-34.39-28.14-46.07-46.79s-17.36-42.17-10.33-63,29-37.1,50.63-33.23c.21,0,3.46,11.46,4,12.57a60.52,60.52,0,0,0,7.2,12c5.51,7.19,12.89,13.8,21.18,17.64,16.78,7.77,25.2-14.81,36.85-22.87A48.34,48.34,0,0,1,998.91,861.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.77,620.54c4.45-16.31,17-30.62,33.14-35.5s35.47.8,45.07,14.71c10.82-12.65,23.68-24.41,39.57-29.38s35.31-1.58,45.42,11.65c5.83,7.63,8,17.6,7.6,27.2s-3.07,18.95-6.1,28.06a369.79,369.79,0,0,1-85.53,140.56c-13.46,13.82-30.15,27.41-49.42,26.55-12-.54-23.12-6.8-31.57-15.27s-14.46-19-19.72-29.78c-6.52-13.33-12-29.51-4.74-42.49,5-9,14.75-14,22.46-20.71,9.72-8.51,12-19.21,8.21-31.09C1183.34,650,1179.42,636.46,1183.77,620.54Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 549.87,
    cy: 255.03,
    r: 65.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 493.38,
    cy: 284.91,
    r: 11.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.2,253.72c-2.48,6.48,1.27,12.87,5.75,14s10.83-3,11.45-10Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "exchange credit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit_card",
    "data-name": "credit card"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M901.92,57.42l142.84-12.17a6.47,6.47,0,0,1,7,6l6.58,98a6.46,6.46,0,0,1-6,6.89L910.25,166.82a6.47,6.47,0,0,1-7-6L896,64.36A6.48,6.48,0,0,1,901.92,57.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "888.92 103.05 1057.52 87.61 1060.56 112.25 890.88 128.29 888.92 103.05"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1013.25,
    cy: 69,
    r: 7.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1022.61,
    cy: 68.12,
    r: 7.34
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "right_hand",
    "data-name": "right hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M594.12,288.48c13.42-19.86,36-10,89.85-26.1,23.17-6.92,71.94-23.23,109.55-64.21,11.68-12.73,22.13-27.23,28.84-43.1a15.67,15.67,0,0,1,21.88-7.78,128.66,128.66,0,0,1,49.55,48.11,15.81,15.81,0,0,1,1.05,13.77C848.84,325.3,774,404.58,698.2,405.4c-12.07.13-59.92.64-88.91-33.95C590.4,348.93,579,310.88,594.12,288.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M711.22,404.48s12.34-23.89,1.36-55.57"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M821.82,151.26c-1.94-19.84,1.3-47.42,22.92-76.89,0,0,5.51-17.1,9.47-28.59a20.3,20.3,0,0,1,23.63-13.25c7.64,1.73,16.25,6.88,23.68,19.27C905,32,923.23,19.23,940.3,22.05c13.73,2.26,25.13,14.3,27.37,29.75l-20,3.25s-2.23,38.41-46.31,47.71l1.78,28.83a34.29,34.29,0,0,0,37.19,32.07l52.7-4.55s13.48,41.78-34.38,31.13c0,0-17.32-2.24-26.83,6.5a47.44,47.44,0,0,1-8.84,6.6c-12.08,6.74-38.86,17.62-66.81,1.88C836.52,194.14,824,173.73,821.82,151.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M901.1,55.06s-17.78,14.57-22.88,54.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M866.42,108.83s12.16-1.89,19.47,7.55"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 947.7,
    y1: 97.67,
    x2: 1040.87,
    y2: 89.13
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand",
    "data-name": "left hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M499.46,300.76S333.81,287.43,290.32,587.44c3.72,4.78,15.32,18.46,35.66,23.69,28.37,7.3,51-7.68,54.53-10.11a196,196,0,0,1,20.4-50.94c16.36-28.92,45-64.73,94.34-92.3,3.75-2.15,42-24.94,46.5-70.85,3.28-33.84-13.1-67.11-42.29-86.17"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "left_finger",
    "data-name": "left finger"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.82,650.46a202.53,202.53,0,0,1,1.63,21.72s10,11.83,14.24,25.74A24,24,0,0,1,400,728.72c-10.82-.74-25.11-4.54-40.47-16.23a125.1,125.1,0,0,0,12.6,27.6,24,24,0,0,1,1.49,23.47c-5.24,10.37-19.2,18.1-55.8-2.37,0,0-23.43,19.18-54-20.36,0,0-26.25,13-38-26.89a94.15,94.15,0,0,1-2.6-40.24c4.73-32.3,21.91-100.52,82.88-109.16,0,0,1.4-.11,4-.13A98.91,98.91,0,0,1,408.82,650.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M264.12,740a88.56,88.56,0,0,1-2.8-68.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M318.33,759.94a110.63,110.63,0,0,1-9.24-82.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.44,715.84a53.08,53.08,0,0,1-6.78-36.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M253,671.74A13,13,0,0,1,268.83,673"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M298.51,678.58a12.38,12.38,0,0,1,17.63,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M346.71,681.15a11.32,11.32,0,0,1,13.88-2.86"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M499.46,300.76c-41.93,14.57-68.07,54.16-64.28,93.84,4.51,47.34,49.25,70,51.78,71.24a170.17,170.17,0,0,1,15.57,32,175.38,175.38,0,0,1,9.25,81.61s-14.54,24.93,24.94,37l203.9-112.56c1.45-2.58,8.38-15.5,2.47-34.43C737,450,720.59,442.07,718,440.85L710,398.08c1.64-9.78,5-37.69-10.95-65-18.57-31.89-55.92-50.3-96.35-48.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.24,376.35A10.9,10.9,0,0,0,582.88,397a12.91,12.91,0,1,0,16.8,14.26,14.54,14.54,0,0,0,26-11.45,12.6,12.6,0,0,0-4.87-7.84,9.76,9.76,0,0,0-9-1.26c6.44-2.18,9.87-10.36,7.32-16.66s-10.24-9.81-16.81-8.08c-6.94,1.84-10.14,7.74-11.85,14.14-1.91-.24-4-3.18-6.22-4A10.94,10.94,0,0,0,576.24,376.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M583.54,389.41c-2.77,7.53,1.27,16.88,8.65,20s16.92-.41,20.44-7.62.09-19.41-7.77-22.58S586.28,382,583.54,389.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.57,535.31c24.57-23.26,54.82-41.09,87.91-48.15s69-2.8,98.06,14.58c5.36,3.2,11.14,8.55,9.45,14.56-1.1,3.88-5,6.21-8.51,8.15L593.12,604c-15.1,8.26-30.43,16.61-47.17,20.62-12.46,3-26.53,3.62-38.78-.72-13.74-4.85-11.74-12.38-5.47-23.41C515.26,576.61,531.62,554.21,551.57,535.31Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 717.96,
    y1: 440.85,
    x2: 701.21,
    y2: 451.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 486.96,
    y1: 465.84,
    x2: 495.79,
    y2: 440.25
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "right_leg",
    "data-name": "right leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M822.25,680.54s78.79,56.22,77,161.1A55.49,55.49,0,0,0,929,891.84a106.5,106.5,0,0,0,43.37,11.62,55.54,55.54,0,0,0,55.31-36c15.23-41,29.07-116.17-24.27-200-3.83-4.31-40.51-44.17-97.88-39-54.36,4.88-83,46.19-86.67,51.61"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M913.64,841.54s27.06,27,92.13,6.22"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "left_leg",
    "data-name": "left leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.08,505.86C543.81,531.05,516.41,580,521,631.58a125.23,125.23,0,0,0,13.17,46.14c27.92,54.56,94.76,83.64,160.05,66.31,16.59-4.88,33.45-10.19,50.64-15.74,28.46-9.19,63.19-21,88.29-31.51,0,0,129.82-51.61,306.75,12.18,25.67,9.25,54.71-.64,68.59-24.12.35-.6.7-1.21,1-1.82a57.84,57.84,0,0,0,6.34-18.33c3.27-19.83-4.36-39.86-19.38-53.2a503.54,503.54,0,0,0-91.11-63.85C1040.75,512,950,480,845.23,494.27c0,0-91.43,11-128.16,29.11h0a40.62,40.62,0,0,0-41.21-40.77,184.22,184.22,0,0,0-86.78,23.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M692.79,536.4s12-8.87,23.22-12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M626.06,590.14s39.82,30.42-4.6,74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1172.28,640.87s4.87,34.1-25.42,63.33"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M796,711s104.39-57.73,265.77-23.94"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_1",
    "data-name": "shoe 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.91,861.34c20.65,1.56,39.28,18,43.38,38.32,2.13,10.53.67,21.48,2.1,32.12,2.37,17.73,12.48,33.34,18.87,50.05,4.46,11.67,7.14,24.27,5.71,36.68s-7.34,24.63-17.47,32-23.79,9.13-36.27,7.08S991.11,1050,980,1044c-26.63-14.28-51.48-31.68-75.27-50.32-17.31-13.57-34.39-28.14-46.07-46.79s-17.36-42.17-10.33-63,29-37.1,50.63-33.23c.21,0,3.46,11.46,4,12.57a60.52,60.52,0,0,0,7.2,12c5.51,7.19,12.89,13.8,21.18,17.64,16.78,7.77,25.2-14.81,36.85-22.87A48.34,48.34,0,0,1,998.91,861.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1061.79,1016.08c-17.56-4.85-38,5.29-44.7,22.21a318.61,318.61,0,0,1-140-99.58c-8.71-10.82-16.77-22.33-22.2-35.12s-8.13-27-5.85-40.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1003.4,930.57c-5.58,5.44-8,13.53-7.83,21.31s2.89,15.33,6.4,22.28c4.27,8.49,10.2,16.64,18.75,20.79s20.13,3.09,26-4.4c5.67-7.27,4.39-17.71,1.67-26.52C1043.14,947.1,1026.08,908.42,1003.4,930.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1008.68,
    cy: 949.84,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1014.84,
    cy: 966.81,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1022.61,
    cy: 982.14,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1038.81,
    cy: 978.2,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1033.08,
    cy: 961.51,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1026.5,
    cy: 944.26,
    r: 3.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.63,884.3a23.93,23.93,0,0,0,23.85-5A26.59,26.59,0,0,0,896.31,856a21.06,21.06,0,0,0-6.58-12.7c-6.86-6-17.76-5.27-25.44-.42-6.23,3.93-15.3,13.23-15.1,21.2C849.4,872.3,857.17,881.57,864.63,884.3Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_2",
    "data-name": "shoe 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.77,620.54c4.45-16.31,17-30.62,33.14-35.5s35.47.8,45.07,14.71c10.82-12.65,23.68-24.41,39.57-29.38s35.31-1.58,45.42,11.65c5.83,7.63,8,17.6,7.6,27.2s-3.07,18.95-6.1,28.06a369.79,369.79,0,0,1-85.53,140.56c-13.46,13.82-30.15,27.41-49.42,26.55-12-.54-23.12-6.8-31.57-15.27s-14.46-19-19.72-29.78c-6.52-13.33-12-29.51-4.74-42.49,5-9,14.75-14,22.46-20.71,9.72-8.51,12-19.21,8.21-31.09C1183.34,650,1179.42,636.46,1183.77,620.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1313.51,573.76a24.29,24.29,0,0,0,26.38,31.14A406,406,0,0,1,1277,723.59c-14.46,18.88-31.21,37-52.81,46.91a90.94,90.94,0,0,1-70.81,1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1269.52,619.72c5,4.29,12.66,4.71,18.68,2s10.48-8.2,13.17-14.23,3.74-12.67,4.41-19.25c.46-4.5.73-9.12-.45-13.48s-4.06-8.5-8.29-10.11c-5.38-2-11.44.37-16.21,3.58-8.16,5.49-17.09,15.09-19.2,25C1260,601.12,1263.36,614.45,1269.52,619.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1275.26,
    cy: 612.88,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1287.4,
    cy: 602.87,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1298.01,
    cy: 592.21,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1291.53,
    cy: 581.44,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1279.24,
    cy: 590.74,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1268.84,
    cy: 599.81,
    r: 3.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1180.73,739.5c5.87,4.37,8.14,12.52,6.73,19.71s-6,13.43-11.53,18.23c-4.67,4-11.06,7.36-16.87,5.24-10.25-3.75-18.93-25.16-13.09-34.76C1152.13,737.78,1171,732.26,1180.73,739.5Z"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "hair_buns",
    "data-name": "hair buns"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M508.29,188.32a29.64,29.64,0,0,0-47.77-30.56c-6.93,5.92-10.74,14.63-16.33,21.84s-14.73,13.3-23.39,10.46c-6.42-2.1-10.48-8.51-12.58-14.93s-2.83-13.27-5.39-19.51a35.11,35.11,0,0,0-58.36-10.39c-6.53,7.13-9.81,16.54-14.22,25.14S319.39,187.5,310,189.9c-12.12,3.1-23.87-5-35.22-10.2-26.09-12.08-57.79-9.62-83.09,4s-44.27,37.65-54.38,64.57c-13.49,35.9-11.22,78.13,9,110.71s58.95,53.72,97.11,49.89,73-34.24,79-72.13c2.22-14.12.68-28.54,1.15-42.83s3.32-29.29,12.73-40.06,25.05-17.72,26.56-31.78c.83-7.74-3.22-15.06-4.88-22.67s.62-17.6,8.21-19.31c8.29-1.88,14.8,8.08,14.6,16.58s-4.17,16.61-4.11,25.11a26.74,26.74,0,0,0,46.54,17.8c8.87-9.75,9.71-25,18.78-34.53,10.89-11.49,26.08-8.22,37.7-.48C491.93,212.76,504.81,200.73,508.29,188.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 506.59,
    cy: 211.61,
    rx: 32.06,
    ry: 25.87,
    transform: "translate(37.93 497.57) rotate(-54.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M481,204.78s5.21-19.81,28.41-23.08"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 549.87,
    cy: 255.03,
    r: 65.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M592.1,195.22c3.57,6,.66,14.32-5,18.32s-13.31,4.34-20.11,2.82-13.08-4.72-19.52-7.37c-3.16-1.3-6.58-2.49-9.92-1.79s-6.36,4-5.48,7.32,4.82,4.77,6.2,7.85c1.73,3.84-1.41,8.38-5.29,10s-8.26,1.35-12.45,1.75-8.77,1.87-10.75,5.58c-3.27,6.12,2.49,13.47,1.47,20.33-.88,6-6.47,9.85-10.62,14.22A35.61,35.61,0,0,0,491,297.6c-7.8-5.21-11-15.08-12.33-24.36-3.12-21.45,1-44.2,13-62.22s32.29-30.78,53.93-32.07,44,9.71,54.74,28.54l1.51-1.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 558.67,
    cy: 257.79,
    r: 6.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M584,232.16l8.64,9.36a5.14,5.14,0,0,1,6.91,1.28,5.06,5.06,0,0,1-.4,5.9"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    "data-name": "Layer 20"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 493.38,
    cy: 284.91,
    r: 11.23
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M487.68,284.18a6,6,0,0,1,10.19-4.26"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "right_eyebrow",
    "data-name": "right eyebrow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 560.35,
    cy: 233.11,
    rx: 7.62,
    ry: 4.25,
    transform: "translate(-25.51 391.55) rotate(-37.72)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow",
    "data-name": "left eyebrow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 592.24,
    cy: 220.11,
    rx: 3.69,
    ry: 7.28,
    transform: "translate(298.86 779.69) rotate(-82.72)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "right_eye",
    "data-name": "right eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 571.43,
    cy: 241.83,
    r: 3
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.2,253.72c-2.48,6.48,1.27,12.87,5.75,14s10.83-3,11.45-10Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M581.52,262.47a5.7,5.7,0,0,1,4.72,1.5,3,3,0,0,1,1,2.95,2.59,2.59,0,0,1-1.78,1.51,6.11,6.11,0,0,1-2.41.06c-1.53-.19-5.2-.4-5.42-2.46S579.88,262.72,581.52,262.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M578.9,257.51a5.19,5.19,0,0,0,2.45,1.32,27.14,27.14,0,0,0,4.62,1,5.91,5.91,0,0,0,3.39-.35,2.35,2.35,0,0,0,1.24-2.86,3.09,3.09,0,0,0-1.38-1.27,16,16,0,0,0-6.49-2.07c-1.41-.14-3.76-.49-4.33,1.22A3.14,3.14,0,0,0,578.9,257.51Z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "left_eye",
    "data-name": "left eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.35,
    cy: 230.11,
    r: 2.88
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangecredit01);
export default __webpack_public_path__ + "static/media/exchange credit-01.3fb3b0d860ca2afb010fe966b8bc0b7e.svg";
export { ForwardRef as ReactComponent };